import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import Logger, { LOG_LEVELS } from '../../../utils/log';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import DeleteLogLines from "../reportDefinition/DeleteLogLines.json";
import getClientConfig from '../../../utils/getClientConfig';
import moment from 'moment';

const log = new Logger('DATA_MINING_DELETE_LOG_PAGE', LOG_LEVELS.DEBUG);

const DeleteLogColumnMapping = {
    "nr": "Nr", "dateOfDeletion": "Date Of Deletion", "companyCode": "Company Code", "companyName": "Company Name", "invoiceNumber": "Invoice Number", "invoiceDate": "Invoice Date",
    "deletedBy": "Deleted By", "reasonOfDeletion": "Reason Of Deletion", "parentFileName": "ParentFileName"
};

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

const { userActivityLogCutoffDate } = getClientConfig();

export class DeleteLogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'Delete log'
            },
            filterCriteria: props.filterCriteria,
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }


    getParameters(selection, pagination) {
        // Apply end-date cut-off logic conditionally for Delete log
        const isIamUser = this.props.iamData && this.props.iamData.isIamUser;
        let adjustedEndDate = selection.endDate;
        if (isIamUser && selection.endDate && moment(selection.endDate).isAfter(moment(userActivityLogCutoffDate))) {
            adjustedEndDate = userActivityLogCutoffDate;
        }
        
        let params = {
            companyId: selection.companyId,
            periodStartDate: selection.startDate,
            periodEndDate: adjustedEndDate,
            startAt: pagination.startAt,
            count: pagination.pageSize,
            sortAscending: selection.sortAscending
        };
        return params;
    }


    getColumns() {
        var columnData = DeleteLogLines;

        log.debug('render(): columnData', columnData);

        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                maxWidth: item.MaxWidth !== undefined ? item.MaxWidth : 1000,
            }
        })
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });
        //To set default/hidden properties of react table
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

        this.props.doGetDeleteLogData(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);           
            let deleteLogData = this.props.deleteLogData || [];
            let totalCount = (this.props.deleteLogData && this.props.deleteLogData.totalCount) || deleteLogData.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if (!nextProps.isReportTypeChanged && (nextProps.filterCriteria !== this.props.filterCriteria)) {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }

    render() {
        log.debug('render() - props: ', this.props);
        let pagination = this.state.pagination || Object.assign({}, DEFAULT_PAGINATION_CONFIG);        
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page =pagination.page;
        }
        const columns = this.getColumns();
        let deleteLogData = (this.props.deleteLogData && this.props.deleteLogData.data) || [];
        for (var key in DeleteLogColumnMapping) {
            deleteLogData = JSON.parse(JSON.stringify(deleteLogData).split('"' + key + '":').join('"' + DeleteLogColumnMapping[key] + '":'));
        }
        let columnData = DeleteLogLines;
        let dateCols = columnData.filter((column) => column.IsDate).map(column => column.Accessor);
        let currencyCols = columnData.filter((column) => column.IsCurrency).map(column => column.Accessor);
        let dateAndCurrencyFormatedDeleteLogData = deleteLogData.map(dataRow => {
            dateCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? `${dataRow[accessor]}`.substr(0, 10) : dataRow[accessor];
                const formattedDate = (dataRow[accessor] === "1899-12-30" ? "" : dataRow[accessor])
                dataRow[accessor] = formattedDate
            });
            currencyCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? ReactComponentHelper.formatToCurrency(dataRow[accessor]) : dataRow[accessor];
            });
            return dataRow;
        });
        let fileName = (this.state.selection && this.state.selection.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : "DataMining.csv"

        const NoDataComponent = props => (
            <NoData
                noDataText="transactionReports_NoData"
                {...props}
            />
        )

        return (
            <div data-test="component-delete-log-page">
                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    minRows={0}
                    maxRows={0}
                    ref={ref => this.viewTable = ref}
                    data={deleteLogData}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(deleteLogData) ? 'mb30 hide-header' : 'mb30'}
                    PaginationComponent={Pagination}
                    showPagination={deleteLogData.length === 0 ? false : true}
                />
                <CSVLink
                    data={sanitizeCsvData(dateAndCurrencyFormatedDeleteLogData)}
                    filename={fileName}
                    className={dateAndCurrencyFormatedDeleteLogData && dateAndCurrencyFormatedDeleteLogData.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='viewTransmission_ExportToCSV' />
                </CSVLink>
            </div>
        );
    }
}


DeleteLogPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
}

function mapStateToProps(state) {
    return {
        languages: state.languages,
        deleteLogData: (state.dataMining && state.dataMining.deleteLog),
        iamData: state.authentication && state.authentication.data && state.authentication.data.iamData
    }
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.doGetDeleteLogData = (params, callback) => {

        log.debug('doGetDeleteLogData');
        dispatch(DATA_MINING_CONTROLLER.doGetDeleteLogData(params, callback));
    }
    return dispatchProps;
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(DeleteLogPage);